<template>
  <div>
    <div id="calendar" class="calendar"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    $(function() {
      $("#calendar").calendar({
        ifSwitch: true, // 是否切换月份
        hoverDate: true, // hover是否显示当天信息
        backToday: true // 是否返回当天
      });

      $("#calendar-date li").click(function() {
        alert($(this).attr("data")); // 获取当日日期
        $(this)
          .addClass("navClicked")
          .siblings()
          .removeClass("navClicked");
      });
    });
  }
};
</script>
